import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardBody, Col } from "reactstrap";
import TableContainer from "../../components/Common/TableContainer";
import { fetchWebVisitorsRequest } from "../../store/Dashboard/dashboardAction";

const LatestWebVisitors = () => {
  const dispatch = useDispatch();
  const { data: webVisitorsData, loading, error } = useSelector(
    (state) => state.webVisitors
  );
  const [selectedDays, setSelectedDays] = useState(1);

  useEffect(() => {
    dispatch(fetchWebVisitorsRequest( selectedDays ));
  }, [dispatch, selectedDays]);
  

  const handleSelectChange = (event) => {
    const days = parseInt(event.target.value, 10);
    setSelectedDays(days);
  };
  
  const columns = [
    { Header: "No.", accessor: "index" },
    { Header: "Email", accessor: "email" },   
    {
      Header: "Lead",
      accessor: "lead",
      Cell: ({ value }) => (
        <span
          style={{
            padding: "6px",
            border: value ? "1px solid #c6d8f2" : "1px solid #d3d6d9",
            borderRadius: "3px",
          }}
          className={`badge ${
            value ? "bg-primary-subtle text-primary" : "bg-secondary-subtle text-secondary"
          }`}
        >
          {value ? "✔ Lead" : "❌ No Lead"}
        </span>
      ),
    },
    {
      Header: "Add To Cart",
      accessor: "addtocart",
      Cell: ({ value }) => (
        <span
          style={{
            padding: "6px",
            border: value ? "1px solid #b6e4d4" : "1px solid #f8d3d4",
            borderRadius: "3px",
          }}
          className={`badge ${
            value ? "bg-success-subtle text-success" : "bg-danger-subtle text-danger"
          }`}
        >
          {value ? "🛒 Added" : "➖ Not Added"}
        </span>
      ),
    },
    {
      Header: "Purchase",
      accessor: "purchase",
      Cell: ({ value }) => (
        <span
          style={{
            padding: "6px",
            border: value ? "1px solid #b6e4d4" : "1px solid #f7e6b5",
            borderRadius: "3px",
          }}
          className={`badge ${
            value ? "bg-success-subtle text-success" : "bg-warning-subtle text-warning"
          }`}
        >
          {value ? "💰 Purchased" : "⛔ Not Purchased"}
        </span>
      ),
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ value }) => <span className="text-dark fw-bold">{value ? `$${value}` : ""}</span>,
    },
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
    {
      Header: "Tags",
      accessor: "tags",
      Cell: ({ value }) =>
        value ? (
          <div>
            {value.split(",").map((tag, idx) => (
              <span
                key={idx}
                style={{
                  background: "#f1f5f7",
                  padding: "7px",
                  border: "1px solid #d3d6d9",
                  borderRadius: "3px",
                }}
                className="badge text-dark text-capitalize"
              >
                {tag.trim()}
              </span>
            ))}
          </div>
        ) : (
          "N/A"
        ),
    },
  ];

  return (
    <Col lg={12}>
      <Card>
        <CardBody>
          <div className="float-end">
            <select
              className="form-select form-select-sm"
              value={selectedDays}
              onChange={handleSelectChange}
            >
              <option value={1}>24 hrs</option>
              <option value={5}>5 Days</option>
              <option value={7}>7 Days</option>
            </select>
          </div>

          <h4 className="card-title mb-4">Latest Web Visitors</h4>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-danger">Error: {error}</p>
          ) : (
            <div className="table-responsive overflow-hidden">
              <TableContainer
                columns={columns}
                data={webVisitorsData}
                isPagination={true}
                isGlobalFilter={false}
                iscustomPageSize={true}
                customPageSize={10}
                className="custom-header-css table align-middle table-nowrap"
                tableClassName="table-bordered align-middle table-nowrap mb-0 border"
                theadClassName="text-muted table-light"
              />
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default LatestWebVisitors;
